/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Follow_Requests_TitleInputs */

const en_follow_requests_title = /** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow Requests`)
};

const es_follow_requests_title = /** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitudes de Seguimiento`)
};

const fr_follow_requests_title = /** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demandes d'abonnement`)
};

const de_follow_requests_title = /** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follower-Anfragen`)
};

const id_follow_requests_title = /** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permintaan Ikuti`)
};

/** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */
const ja_follow_requests_title = en_follow_requests_title;

/** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */
const zh_follow_requests_title = en_follow_requests_title;

/** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */
const ar_follow_requests_title = en_follow_requests_title;

/** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */
const it_follow_requests_title = en_follow_requests_title;

/** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */
const ru_follow_requests_title = en_follow_requests_title;

/** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */
const pt_follow_requests_title = en_follow_requests_title;

/** @type {(inputs: Follow_Requests_TitleInputs) => LocalizedString} */
const ko_follow_requests_title = en_follow_requests_title;

/**
* | output |
* | --- |
* | "Follow Requests" |
*
* @param {Follow_Requests_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const follow_requests_title = /** @type {((inputs?: Follow_Requests_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Follow_Requests_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_follow_requests_title(inputs)
	if (locale === "es") return es_follow_requests_title(inputs)
	if (locale === "fr") return fr_follow_requests_title(inputs)
	if (locale === "de") return de_follow_requests_title(inputs)
	if (locale === "ja") return ja_follow_requests_title(inputs)
	if (locale === "zh") return zh_follow_requests_title(inputs)
	if (locale === "ar") return ar_follow_requests_title(inputs)
	if (locale === "id") return id_follow_requests_title(inputs)
	if (locale === "it") return it_follow_requests_title(inputs)
	if (locale === "ru") return ru_follow_requests_title(inputs)
	if (locale === "pt") return pt_follow_requests_title(inputs)
	return ko_follow_requests_title(inputs)
});